import _ from 'underscore';
import ko from 'knockout';
import * as url from '@bingads-webui/url-util';

export default class ViewModel {
  constructor({
    trackingTemplate,
    i18n,
    editMode,
    showUurlTestTool,
  }) {
    this.editMode = ko.observable(editMode);

    this.maxLength = 2048;

    this.trackingTemplate = ko.observable(trackingTemplate);

    this.inputClass = showUurlTestTool ? ['with-test-button form-control'] : ['full-width form-control'];

    this.validate = (newTrackingTemplate) => {
      let errorList = [];
      if (!url.hasScheme(newTrackingTemplate) &&
        !_.find(
          ['{lpurl}', '{unescapedlpurl}'],
          tag => newTrackingTemplate.indexOf(tag) === 0
        )) {
        errorList = _.union(errorList, [i18n.getString('Error_Campaign_API_InvalidUrlScheme')]);
      }

      return errorList;
    };

    this.errorMessages = ko.computed(() => {
      if (this.trackingTemplate()) {
        return this.validate(this.trackingTemplate());
      }
      return [];
    });

    this.showNone = ko.computed(() => !this.editMode() && !this.trackingTemplate());

    this.isValid = ko.computed(() => !this.errorMessages().length, this);
  }
}
